/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ week: NonNullable<unknown> }} Workout_After_WeekInputs */

const en_us2_workout_after_week = /** @type {(inputs: Workout_After_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Week ${i?.week}`)
};

const pt_br2_workout_after_week = /** @type {(inputs: Workout_After_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semana ${i?.week}`)
};

const es_419_workout_after_week = /** @type {(inputs: Workout_After_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semana ${i?.week}`)
};

const pt_pt2_workout_after_week = /** @type {(inputs: Workout_After_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semana ${i?.week}`)
};

const fr_fr2_workout_after_week = /** @type {(inputs: Workout_After_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Semaine ${i?.week}`)
};

const de_de2_workout_after_week = /** @type {(inputs: Workout_After_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Woche ${i?.week}`)
};

const it_it2_workout_after_week = /** @type {(inputs: Workout_After_WeekInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Settimana ${i?.week}`)
};

/**
* | output |
* | --- |
* | "Week {week}" |
*
* @param {Workout_After_WeekInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_week = /** @type {((inputs: Workout_After_WeekInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_WeekInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_week(inputs)
	if (locale === "es-419") return es_419_workout_after_week(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_week(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_week(inputs)
	if (locale === "de-DE") return de_de2_workout_after_week(inputs)
	if (locale === "it-IT") return it_it2_workout_after_week(inputs)
	return en_us2_workout_after_week(inputs)
});
export { workout_after_week as "workout-after.week" }